import type { RequestInterface } from '~/common/types';

export class WorkSitesListRequest implements RequestInterface {
  method = 'get';
  path = '/api/v1/worksites-list';
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    params,
  }: {
    token: string;
    params?: Record<string, any>;
  }) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}
